const setStorageItem = () => {
  const item = { blocked: true, deletedAt: new Date().getTime() + 3600000 };
  localStorage.setItem('maxResendAttempts', JSON.stringify(item));
};

const getStorageItem = () => {
  return localStorage.getItem('maxResendAttempts');
};

const getUserLockedItem = () => {
  return localStorage.getItem('userLocked');
};

const autodeleteItem = () => {
  const item = localStorage.getItem('maxResendAttempts');
  const currentTimestamp = new Date().getTime();
  if (item !== null) {
    if (JSON.parse(item).deletedAt < currentTimestamp) {
      localStorage.removeItem('maxResendAttempts');
      localStorage.removeItem('userLocked');
    }
  }
};

export { setStorageItem, getStorageItem, getUserLockedItem, autodeleteItem };
